/**
 * 유니폼 수령 상태 타입 및 라벨
 */

export type UniformDeliveryStatus = 'new' | 'ready' | 'received';

/** 상태 한글 라벨 */
export const getUniformDeliveryStatusLabel = (status: UniformDeliveryStatus): string => {
  switch (status) {
    case 'new':
      return '신규';
    case 'ready':
      return '수령대기';
    case 'received':
      return '수령완료';
    default:
      return '-';
  }
};
